import {
  CAMPAIGN_TEMPLATE_VALUE_TYPES,
  TEXT_TO_WIN_TEMPLATE_VALUE_TYPES,
} from 'src/constants/templateValueTypes';
import { CampaignConfigSchema } from '../types/campaignConfigSchema';

// Campaign configs only. Non-campaign contexts (away messages, settings templates,
// custom fields) have no config and no appointment context — they read the
// non-campaign constant from src/constants/templateValueTypes directly.
export const getTemplateDefaultValueTypes = (
  config: Pick<CampaignConfigSchema, 'type'>,
): string => {
  if (config.type === 'text_to_win') {
    return TEXT_TO_WIN_TEMPLATE_VALUE_TYPES;
  }
  // Campaign message types expose appointment placeholders; non-reminder messages
  // only surface them once an appointment is attached (per-message gating in
  // MessageForm via filterPlaceholdersForAppointment).
  return CAMPAIGN_TEMPLATE_VALUE_TYPES;
};
